/* eslint-disable no-template-curly-in-string */
export const MockAccountListSingleEndpointKeyThree = {
  result: {
    accounts: [
      {
        accountKey: 1074,
        name: 'pamtestuser@saviyntcloud.net',
        accountId: '108280038023514724186',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '360000',
          maxrequestabletimeinsecs: '360000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        updateDate: '2023-10-23T10:14:01.000+00:00',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 3,
        endpointName: 'GCP-SA',
        endpointDisplayName: 'GCP-SAdisplaynameeeeeeeeeeeeeeeeeee',
        assetType: 'Application',
        applicationTypeKey: 8,
        applicationTypeName: 'GCP-Organization',
        applicationTypeDisplayName: 'Google Cloud Platform',
        remoteAppEnabled: true,
        remoteAppDetails: [
          {
            key: 'googlecloudlogin',
            displayName: 'Web App',
            icon: 'webapp',
            setup: 'PAM_REMOTE_APP_SETUP',
            internalAttr: {
              client:
                'https://console.cloud.google.com/home/dashboard?login=true&ref=https:%2F%2Fconsole.cloud.google.com%2Fhome%2Fdashboard',
            },
            commandTemplate: '${username} ${password} ${client}',
          },
        ],
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'GCPConsole',
        endpointStatus: 1,
      },
      {
        accountKey: 273,
        name: 'servaccuser@cloudteamgapp-534276.iam.gserviceaccount.com',
        accountId: 'servaccuser@cloudteamgapp-534276.iam.gserviceaccount.com',
        description: 'Test Description Account',
        pamType: 'CREDENTIAL',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '100',
          maxrequestabletimeforidinsecs: '100',
          defaultrequestabletimeinsecs: '1200000',
          maxrequestabletimeinsecs: '1200000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        updateDate: '2023-09-28T05:11:02.000+00:00',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 3,
        endpointName: 'GCP-SA',
        endpointDisplayName: 'GCP-SAdisplaynameeeeeeeeeeeeeeeeeee',
        assetType: 'Application',
        applicationTypeKey: 8,
        applicationTypeName: 'GCP-Organization',
        applicationTypeDisplayName: 'Google Cloud Platform',
        remoteAppEnabled: true,
        remoteAppDetails: [
          {
            key: 'googlecloudlogin',
            displayName: 'Web App',
            icon: 'webapp',
            setup: 'PAM_REMOTE_APP_SETUP',
            internalAttr: {
              client:
                'https://console.cloud.google.com/home/dashboard?login=true&ref=https:%2F%2Fconsole.cloud.google.com%2Fhome%2Fdashboard',
            },
            commandTemplate: '${username} ${password} ${client}',
          },
        ],
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'GCPConsole',
        endpointStatus: 1,
      },
    ],
  },
  count: 2,
};

export const MockAccountListSingleEndpointKeyFour = {
  result: {
    accounts: [
      {
        accountKey: 4455,
        name: 'pam3-sumantuser-eddsa',
        accountId: '1266',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        updateDate: '2023-08-18T05:01:14.000+00:00',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 3562,
        name: 'cpamuser',
        accountId: '1241',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: '',
            showPassword: 'ENABLED',
          },
        },
        accountType: 'FIREFIGHTERID',
        updateDate: '2023-08-17T05:20:54.000+00:00',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 4397,
        name: 'manjuConn',
        accountId: '1259',
        pamType: 'CREDENTIAL',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '0',
          maxrequestabletimeforidinsecs: '0',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '0',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: 'DISABLED',
          },
        },
        accountType: 'FIREFIGHTERID',
        updateDate: '2023-08-14T10:24:37.000+00:00',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 3549,
        name: 'sanjna_pam1',
        accountId: '1251',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '',
          maxrequestabletimeinsecs: '',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: 'true',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        updateDate: '2023-07-27T07:11:25.000+00:00',
        pamAccountType: 'Temporary Privileged Account (JIT)',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 3466,
        name: 'sumantlocaladmin',
        accountId: '1250',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '',
          maxrequestabletimeinsecs: '',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: 'true',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        updateDate: '2023-07-27T07:11:25.000+00:00',
        pamAccountType: 'Temporary Privileged Account (JIT)',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 3383,
        name: 'testathon_23_7',
        accountId: '1221',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '6000',
          maxrequestabletimeinsecs: '60000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        updateDate: '2023-06-20T18:35:24.000+00:00',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 520,
        name: 'pam3-test3',
        accountId: '1120',
        pamType: 'CREDENTIAL',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '12000',
          maxrequestabletimeforidinsecs: '72000',
          defaultrequestabletimeinsecs: '72000',
          maxrequestabletimeinsecs: '72000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        updateDate: '2023-05-26T08:58:42.000+00:00',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 1127,
        name: 'gaurav',
        accountId: '1213',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '',
          maxrequestabletimeinsecs: '',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: 'true',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        updateDate: '2023-05-08T07:45:08.000+00:00',
        pamAccountType: 'Temporary Privileged Account (JIT)',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 518,
        name: 'pam3-test1',
        accountId: '1118',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '72000',
          maxrequestabletimeinsecs: '72000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        updateDate: '2023-05-03T10:44:14.000+00:00',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 522,
        name: 'pam3-unixadmin',
        accountId: '1122',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '600',
          maxrequestabletimeinsecs: '600',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 3561,
        name: 'cpamuser1',
        accountId: '1240',
        pamType: 'CREDENTIAL',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 521,
        name: 'pam3-test4',
        accountId: '1121',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '10000',
          maxrequestabletimeforidinsecs: '10000',
          defaultrequestabletimeinsecs: '72000',
          maxrequestabletimeinsecs: '72000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 3570,
        name: 'pam3-ed25119usr',
        accountId: '1253',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '72000',
          maxrequestabletimeinsecs: '72000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 3571,
        name: 'pam3-ed25119',
        accountId: '1254',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '72000',
          maxrequestabletimeinsecs: '72000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 3572,
        name: 'pam3-ed25519key',
        accountId: '1255',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '72000',
          maxrequestabletimeinsecs: '72000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 3574,
        name: 'sumantkeysold',
        accountId: '1257',
        pamType: 'CREDENTIAL',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '72000',
          maxrequestabletimeinsecs: '72000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
      {
        accountKey: 519,
        name: 'pam3-test2',
        accountId: '1119',
        pamType: 'CREDENTIALLESS',
        accountConfig: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '72000',
          maxrequestabletimeinsecs: '72000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIALLESS',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        pamAccountType: 'Shared Account',
        federatedAccount: false,
        status: '1',
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endpointDisplayName: 'epam-poc-unixinstance-new',
        epCustomproperty5: 'CloudPAM',
        epCustomproperty9: '34.133.74.177',
        epCustomproperty10: 'us-central1-a',
        epCustomproperty16: 'Unix',
        assetType: 'Server',
        applicationTypeKey: 6,
        applicationTypeName: 'GCP-Linux',
        applicationTypeDisplayName: 'GCP-Linux',
        sendTargetEndpointKey: false,
        exclusiveAccess: false,
        connectionType: 'GCP',
        platformType: 'GCP',
        pamPlatformType: 'UNIX',
        endpointStatus: 1,
      },
    ],
  },
  count: 17,
};

export const MockAccountListALL = {
  result: {
    accountsResponseList: [
      {
        inUseBy: null,
        accountkey: 1113,
        accountName: 'rajesh_svc1',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '2592000',
          maxrequestabletimeforidinsecs: '2592000',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'NEW',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: null,
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 1129,
        accountName: 'unix-sa-iga',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '',
          maxrequestabletimeinsecs: '',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: '',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: '1212',
        accountDescription: null,
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endPointDisplayname: 'epam-poc-unixinstance-new',
        privateIp: '34.133.74.177',
        publicIp: '34.133.74.177',
        port: '22',
        platformType: 'UNIX',
        connectionType: 'GCP',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 4628,
        accountName: 'sfdfsdf',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: 'DISABLED',
          },
        },
        accountType: 'Service Account',
        accountId: 'sfdfsdf',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 4604,
        accountName: 'admin',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: 'DISABLED',
          },
        },
        accountType: 'FIREFIGHTERID',
        accountId: 'admin',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 3478,
        accountName: 'saviynt_test',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '2592000',
          maxrequestabletimeforidinsecs: '2592000',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'saviynt_test',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 3477,
        accountName: 'smartworks',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '2592000',
          maxrequestabletimeforidinsecs: '2592000',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'smartworks',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 3162,
        accountName: 'sumantest20623',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '2592000',
          maxrequestabletimeforidinsecs: '2592000',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'DISABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'sumantest20623',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 2316,
        accountName: 'SVC1Test',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '2592000',
          maxrequestabletimeforidinsecs: '2592000',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'SVC1Test',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 592,
        accountName: 'gtest1',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '',
          maxrequestabletimeinsecs: '',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        accountId: 'gtest1',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: false,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 1098,
        accountName: 'priyanka',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '2592000',
          maxrequestabletimeforidinsecs: '2592000',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'DISABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'priyanka',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: false,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 1086,
        accountName: 'test_changepwd3',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '2592000',
          maxrequestabletimeforidinsecs: '2592000',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'NEW',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'test_changepwd3',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 1024,
        accountName: 'gtest2',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '2592000',
          maxrequestabletimeforidinsecs: '2592000',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'NEW',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'gtest2',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 1020,
        accountName: 'gulshanSvc2',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '2592000',
          maxrequestabletimeforidinsecs: '2592000',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'DISABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'gulshanSvc2',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 1011,
        accountName: 'Test_ChangePwd',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '',
          maxrequestabletimeinsecs: '',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: '',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'Test_ChangePwd',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 4397,
        accountName: 'manjuConn',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '0',
          maxrequestabletimeforidinsecs: '0',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '0',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: 'DISABLED',
          },
        },
        accountType: 'FIREFIGHTERID',
        accountId: '1259',
        accountDescription: null,
        endpointKey: 4,
        endpointName: '5201938467946929247',
        endPointDisplayname: 'epam-poc-unixinstance-new',
        privateIp: '34.133.74.177',
        publicIp: '34.133.74.177',
        port: '22',
        platformType: 'UNIX',
        connectionType: 'GCP',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: true,
      },
      {
        inUseBy: null,
        accountkey: 3484,
        accountName: 'gaurav',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: 'DISABLED',
          },
        },
        accountType: 'FIREFIGHTERID',
        accountId: 'S-1-5-21-2977298395-534424068-4062990217-13649',
        accountDescription: null,
        endpointKey: 15,
        endpointName: '6469536595789482794',
        endPointDisplayname: 'epam-poc-windowsinstance',
        privateIp: '34.75.135.244',
        publicIp: '34.75.135.244',
        port: '3389',
        platformType: 'WINDOWS',
        connectionType: 'GCP',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: false,
      },
      {
        inUseBy: null,
        accountkey: 1021,
        accountName: 'localuser',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '',
          maxrequestabletimeinsecs: '',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'localuser',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: false,
      },
      {
        inUseBy: null,
        accountkey: 1019,
        accountName: 'gulshanSvc',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '',
          maxrequestabletimeinsecs: '',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'gulshanSvc',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: false,
      },
      {
        inUseBy: null,
        accountkey: 3166,
        accountName: 'pam3serviceaccount1',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '2592000',
          maxrequestabletimeforidinsecs: '2592000',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'pam3serviceaccount1',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: false,
      },
      {
        inUseBy: null,
        accountkey: 550,
        accountName: 'pam3_win4',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '',
          maxrequestabletimeinsecs: '',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        accountId: 'S-1-5-21-2977298395-534424068-4062990217-8091',
        accountDescription: 'pamadmin',
        endpointKey: 15,
        endpointName: '6469536595789482794',
        endPointDisplayname: 'epam-poc-windowsinstance',
        privateIp: '34.75.135.244',
        publicIp: '34.75.135.244',
        port: '3389',
        platformType: 'WINDOWS',
        connectionType: 'GCP',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: false,
      },
      {
        inUseBy: null,
        accountkey: 1018,
        accountName: 'preauthasishff1',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '',
          maxrequestabletimeinsecs: '',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        accountId: 'preauthasishff1',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: false,
      },
      {
        inUseBy: null,
        accountkey: 1012,
        accountName: 'acctest123',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '',
          maxrequestabletimeinsecs: '',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'acctest123',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: false,
      },
      {
        inUseBy: null,
        accountkey: 4744,
        accountName: 'QACHECKING12345',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '36000',
          maxrequestabletimeinsecs: '36000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: 'DISABLED',
          },
        },
        accountType: 'Service Account',
        accountId: 'QACHECKING12345',
        accountDescription: null,
        endpointKey: 1,
        endpointName: 'Privileged_Account',
        endPointDisplayname: 'Privileged_Account',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'VaultConsole',
        connectionType: 'REST',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Instance',
        enableAllowed: true,
        disableAllowed: true,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: false,
      },
      {
        inUseBy: null,
        accountkey: 273,
        accountName: 'servaccuser@cloudteamgapp-534276.iam.gserviceaccount.com',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '100',
          maxrequestabletimeforidinsecs: '100',
          defaultrequestabletimeinsecs: '1200000',
          maxrequestabletimeinsecs: '1200000',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'Service Account',
        accountId: 'servaccuser@cloudteamgapp-534276.iam.gserviceaccount.com',
        accountDescription: null,
        endpointKey: 3,
        endpointName: 'GCP-SA',
        endPointDisplayname: 'GCP-SAdisplaynameeeeeeeeeeeeeeeeeee',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'GCPConsole',
        connectionType: 'GCP',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Console',
        enableAllowed: false,
        disableAllowed: false,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: false,
      },
      {
        inUseBy: null,
        accountkey: 2500,
        accountName: 'a-pamowner',
        accountConfigModel: {
          defaultrequestabletimeforidinsecs: '',
          maxrequestabletimeforidinsecs: '',
          defaultrequestabletimeinsecs: '129600',
          maxrequestabletimeinsecs: '129600',
          diffbetweenrequests: '',
          authenticationType: '',
          'Saviynt-Status': {
            pamState: 'ENABLED',
            pamType: 'CREDENTIAL',
            errorDetails: '',
            justInTime: '',
            showPassword: '',
          },
        },
        accountType: 'FIREFIGHTERID',
        accountId: 'e561d512-f220-4d4b-ae13-f8031921f371',
        accountDescription: null,
        endpointKey: 29,
        endpointName: 'AD_PAM3',
        endPointDisplayname: 'AD_PAM3',
        privateIp: null,
        publicIp: null,
        port: null,
        platformType: 'ADConsole',
        connectionType: 'AD',
        requestAccessKey: null,
        requestAccessStatus: null,
        requestId: null,
        requestStartDate: null,
        requestEndDate: null,
        requestUserkey: null,
        sessionStatus: null,
        username: 'pamadmin',
        pamEndpointState: 'ENABLED',
        pamResourceType: 'Console',
        enableAllowed: false,
        disableAllowed: false,
        accountActive: true,
        accessEnabled: false,
        sendTargetEndpointKey: false,
        owner: false,
      },
    ],
  },
  count: 35,
};
